import React from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";

export function Chart({ data, x, lines, testid }) {
  return (
    <div className="card-surface rounded-xl p-5 mt-4" data-testid={testid}>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data} margin={{ left: -10, right: 8 }}>
            <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false} />
            <XAxis dataKey={x} tickFormatter={(v) => (v.includes("-") ? v.slice(5) : `${v.slice(4, 6)}-${v.slice(6)}`)} tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 11 }} axisLine={false} tickLine={false} minTickGap={20} />
            {lines.map((l, i) => <YAxis key={l.key} yAxisId={i} orientation={i ? "right" : "left"} hide={i > 1} allowDecimals={false} tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 11 }} axisLine={false} tickLine={false} />)}
            <Tooltip contentStyle={{ background: "#0d1117", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, color: "#fff" }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {lines.map((l, i) => <Area key={l.key} yAxisId={i} type="monotone" dataKey={l.key} name={l.name} stroke={l.color} fill={i ? "transparent" : `${l.color}33`} strokeWidth={2} />)}
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export function DataTable({ title, icon: Icon, cols, rows, testid }) {
  return (
    <div className="card-surface rounded-xl p-5 mt-4 overflow-hidden" data-testid={testid}>
      <h3 className="font-bold text-white mb-3 flex items-center gap-2"><Icon size={16} /> {title}</h3>
      {!rows.length ? <p className="text-sm text-white/40">No data for this period yet.</p> : (
        <div className="overflow-x-auto -mx-5 px-5">
          <table className="w-full text-sm min-w-[560px]">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-white/40">
              {cols.map((c) => <th key={c.label} className={`pb-2 font-semibold ${c.num ? "text-right" : ""}`}>{c.label}</th>)}
            </tr></thead>
            <tbody>{rows.map((r, i) => (
              <tr key={i} className="border-t border-white/5">
                {cols.map((c) => <td key={c.label} className={`py-2 ${c.num ? "text-right text-white/70 tabular-nums" : "text-white/85 max-w-[340px] truncate"}`} title={c.num ? undefined : String(c.get(r))}>{c.get(r)}</td>)}
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export const fmtDuration = (s) => `${Math.floor(s / 60)}m ${Math.round(s % 60)}s`;
export const pathOf = (u) => { try { return new URL(u).pathname; } catch { return u; } };
